"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenInfo = void 0;
const selectScreen_1 = require("../selectors/selectScreen");
const useSelector_1 = require("./useSelector");
const EMPTY_STATE = {
    name: '',
    author: {
        name: '',
        image: '',
    },
    model_identifier: '',
    model_version: '',
    information: '',
};
function useScreenInfo() {
    return (0, useSelector_1.useSelector)(selectScreen_1.selectScreen) || EMPTY_STATE;
}
exports.useScreenInfo = useScreenInfo;
